<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

      <div class="row">
        
        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Consignaciones
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en recaudos</p>
            </div>
          </div>
        </div>

      
      </div>

      <div class="d-inline mr-4">
        <button type="button" v-b-modal.consignmentManual class="btn btn-primary">
          Consignación Manual
        </button>
      </div>
      <div class="d-inline">
        <button type="button" v-on:click="generateCVS" class="btn btn-primary">
          CSV
        </button>
      </div>

			<div class="float-right">
				<button type="button" v-b-modal.modalFilters class="btn btn-primary">
					Filtros
				</button>
			</div>

			
			


			<div class="table table-padded">
				
        <b-card>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
                
               :items="adminConsignments"
               :fields="fields"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
                @filtered="onFiltered" class="table table-padded"
          >

               <template slot="status" slot-scope="row">
                 <template v-if="row.item.status == 2">
                    Aprobada
                  </template>
                  <template v-else-if="row.item.status == 1">
                    Pendiente
                  </template>
                  <template v-else>
                    Rechazada
                  </template>
               </template>

               <template slot="type" slot-scope="row">
                <template v-if="row.item.eTransfer == 1">
                  Transferencia
                </template>

                <template v-else>
                  Consignación
                </template>

                 
               </template>

               <template slot="createdAt" slot-scope="row">
                 {{row.item.createdAt.substr(0, 10)}}
               </template>

               <template slot="createdAtHour" slot-scope="row">
                 {{row.item.createdAt.substr(11, 5)}}
               </template>

                <template slot="company" slot-scope="row">
                 {{row.item.Company.name}}
               </template>

                <template slot="company" slot-scope="row">
                   {{row.item.observation}}
                </template>


               <template slot="bankImage" slot-scope="row">
                  <img :src="'/banks/'+row.item.bankImage" class="bank">
               </template> 

               <template slot="amount" slot-scope="row">
                <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>
               </template>

              <template slot="anexo" slot-scope="row">
                <button v-if="row.item.image" v-b-modal.modalImage v-on:click="viewImage(row.item)" type="button" class="btn btn-primary">
                    Anexo
                  </button>             
              </template>

              <template slot="amount" slot-scope="row">
                <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>

              </template>

              <template slot="action" slot-scope="row">
                <template v-if="row.item.status == 1" >
                      <button v-on:click="processStatement(row.item, 'reject')"  class="actionBtnTable nobtn" ><i class="material-icons" style="color: #dab51b;" >clear</i></button>
                      <button v-on:click="processStatement(row.item, 'approve')"  class="actionBtnTable"><i class="material-icons" >done</i></button>
                </template>
              </template> 
                 


         
          

  					<!--thead>
  						<tr>
  							<th>{{$t('table.status')}}</th>
                <th>{{$t('table.date')}}</th>
                <th>{{$t('table.hour')}}</th>
                <th>{{$t('table.reference')}}</th>
                <th>{{$t('table.company')}}</th>
  							<th>{{$t('table.description')}}</th>
  							<th>{{$t('table.bank')}}</th>
  							<th>{{$t('table.value')}}</th>
  							<th>{{$t('table.anexo')}}</th>
  							<th>{{$t('table.action')}}</th>
  						</tr>
  					</thead>
  					<tbody>
  						<tr v-for="(consignment,index) in adminConsignments" :key="index">
  							<td>
                  <template v-if="consignment.status == 1">
                    Pendiente
                  </template>
                  <template v-else-if="consignment.status == 2">
                    Aprobada
                  </template>
                  <template v-else-if="consignment.status == 0">
                    Rechazada
                  </template>       
                </td>
  							<td>{{consignment.createdAt.substr(0, 10)}}</td>
                <td>{{consignment.createdAt.substr(11, 5)}}</td>
                <td>{{consignment.reference}}</td>
  							<td>{{consignment.Company.name}}</td>
  							<td>{{consignment.observation}}</td>
  							<td>
  								<img :src="'/banks/'+consignment.bankImage" class="bank">
  							</td>
  							<td>
  								<h2 class="itemIndicator" :class="consignment.type == 'add' ? 'low' : ''">${{money(consignment.amount)}}</h2>
  							</td>
  							<td>
  								<button v-if="consignment.image" v-b-modal.modalImage v-on:click="viewImage(consignment)" type="button" class="btn btn-primary">
  									Anexo
  								</button>
  							</td>
  							<td>
                    <template v-if="consignment.status == 1" >
                      <button v-on:click="processStatement(consignment, 'reject')"  class="actionBtnTable nobtn" ><i class="material-icons" style="color: #dab51b;" >clear</i></button>
                      <button v-on:click="processStatement(consignment, 'approve')"  class="actionBtnTable"><i class="material-icons" >done</i></button>
                    </template> 

  			        </td>
  						</tr>
  					</tbody-->
				</b-table>

        <b-row>
          <b-col md="12" class="my-1 float-right">
            <b-pagination :total-rows="adminConsignments.length" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

        <app-pagination :data="data"/>


        {{total}}
      </b-card >



			
		</div>
    </div>
			
		<app-footer/>

	<b-modal id="modalImage" title="Visualizar anexo">
		<img :src="current.image">
	</b-modal>

	   <b-modal id="modalFilters" ref="modalFilters" centered hide-footer class='box-modal' title = "Filtrar Consignaciones">
      	<form v-on:submit.prevent="read">
      	 <div class="box-modal"> 
      		
      			
      	 <div class="form-group">
			
			    <label class='control-label'>Referencia de pago</label>		
				  <input type="text"  class="form-control" v-model="filters.payReference">		
			  </div>

	      <div class="form-group">
			
  				<label class='control-label'>Fecha Inicial</label>		
  				<input type="date"  class="form-control" v-model="filters.dateStart">		
  			</div>

  			<div class="form-group">
  				<label class='control-label'>Fecha Final</label>		
  				<input type="date"  class="form-control" v-model="filters.dateEnd">		
  			</div>

			
  			<div class="form-group">
  				<label class='control-label'>Código Empresa</label>
  				<input type="text"  class="form-control" v-model="filters.codeCompany">	
  			</div>

  			<div class="form-group">
  				<label class='control-label'>Banco</label>
  				<select class="form-control" v-model="filters.bankId">
			    	<option v-for="(bank, index) in banks" :key="index" :value="bank.id">
			    		{{bank.name}}
			    	</option>
			    </select>	
			  </div>

        <div class="form-group">
          <label class='control-label'>Estado</label>
          <select class="form-control" v-model="filters.status">
            <option value="1" >Pendiente</option>
            <option value="2" >Aprobada</option>
            <option value="0" >Rechazada</option>
          </select> 
        </div>
      </div> 
      <div class="d-inline mr-4">
        <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar</button>
      </div>
      <div class="d-inline">
        <button type="submit" class="btn btn-primary">Filtrar</button>
      </div>
    </form>      
    </b-modal>


    <b-modal id="modalApproveConsignment" ref="modalApproveConsignment" centered size="sm"  title="Aprobar"  @ok="process('approve')">
      <div class="">
        <p>Esta seguro que desea aprobar ésta consignación?</p>

        <div class="form-group">
			<label class='col-lg-12 control-label'>Observación </label>
	    	<textarea type="textarea" class="form-control" v-model='processForm.observation'></textarea>
		</div>
        
      </div>
      
    </b-modal>

    <b-modal id="modalRejectConsignment" ref="modalRejectConsignment" centered size="sm"  title="Rechazar" @ok="process('reject')">
      <div class="">
        <p>Esta seguro que desea rechazar ésta consignación?</p>

        <div class="form-group">
			<label class='col-lg-12 control-label'>Observación </label>
	    	<textarea type="textarea" class="form-control" v-model='processForm.observation'></textarea>
		</div>
        
      </div>     
    </b-modal>

    

    <b-modal id="consignmentManual" ref="consignmentManual" title="Consignación Manual" @ok="reportConsignmentManual()">

     <form v-on:submit.prevent="reportConsignmentManual">

      <div class="form-group">
        <label>Tarjeta de Recaudo</label>
        <input type="text" class="form-control" v-model="report.reference">
      </div>

      <div class="form-group">
        <label>Fecha Consignación</label>
        <input type="date" class="form-control" v-model="report.dateConsignment">
      </div>

      <div class="form-group">
        <label>Hora Consignación</label>
        <input type="time" step="1" class="form-control" v-model="report.hourConsignment">
      </div>


      <div class="form-group">
        <label>Banco</label>
        <select class="form-control" v-model="report.bankId">
              <option v-for="(bank, index) in banks" :key="index" :value="bank.id">
                {{bank.name}}
              </option>
        </select>
      </div>

      <div class="form-group">
        <label>Valor</label>
        <money  v-model="report.value" class="form-control"></money>
      </div>

      <div class="form-group">
        <label>Anexo</label>
        <input type="file" class="form-control" >
      </div>


      <div class="form-group">
        <label>Observación</label>
        <input type="text" class="form-control" v-model="report.observation">
      </div>
    </form>

  </b-modal>


  


</div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMINCONSIGNMENTS,
  FETCH_BANKS,
  PROCESS_CONSIGNMENTS,
  REQUEST_CONSIGNMENTMANUAL
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      current: {},
      filters: {
        payReference: "",
        dateStart: "",
        dateEnd: "",
        codeCompany: "",
        bankId: ""
      },
      report: {
        reference: "",
        dateConsignment: "",
        hourConsignment: "",
        bankId: "",
        value: "",
        observation: "",
        user: ""
      },
      data: {},
      processForm: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "status", label: "Estado", sorteable: true },
        { key: "type", label: "Tipo", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "reference", label: "Referencia", sorteable: true },
        { key: "company", label: "Compañia", sorteable: true },
        { key: "description", label: "Descripción", sorteable: true },
        { key: "bankImage", label: "Imagen", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "anexo", label: "Anexo", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ]
    };
  },

  methods: {
    viewImage(consignment) {
      this.current = consignment;
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    process(type) {
      var data = {
        consignmentId: this.current.id,
        type: type,
        observation: this.processForm.observation
      };
      this.$store
        .dispatch(PROCESS_CONSIGNMENTS, data)
        .then(result => {
          this.processForm = {};
          this.read();
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    reportConsignmentManual() {
      this.$store
        .dispatch(REQUEST_CONSIGNMENTMANUAL, this.report)
        .then(result => {
          this.report = {};
          this.read();
          this.$refs.consignmentManual.hide();
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_ADMINCONSIGNMENTS, this.filters);
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    processStatement(consignment, type) {
      this.current = consignment;
      if (type == "reject") {
        return this.$refs.modalRejectConsignment.show();
      }
      this.$refs.modalApproveConsignment.show();
    },

    generateCVS() {
      var total = 0;
      var rows = this.adminConsignments.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;
        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          "#" + item.reference,
          item.Company.name,
          item.observation,
          item.bankName,
          "$" + item.amount
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Referencia Pago",
          "Empresa",
          "Descripcion",
          "Banco",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Administar_Consignaciones.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["adminConsignments", "banks"]),

    total: function() {
      var total = 0;
      this.adminConsignments.map(row => (total += row.amount));
      return total;
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_BANKS);
    this.read();
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
